import GenericDictionaryPage from "./GenericDictionaryPage";
import { getImprovementPlanOrigin } from "../api/improvementPlanOrigin";

export default function ImprovementPlanOrigin() {
    return (
        <GenericDictionaryPage
            tableKey="improvementPlanOrigin"
            fetchData={getImprovementPlanOrigin}
            titleKey="genericDic:improvementPlanOrigin"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:improvementPlanOrigin").toLowerCase()
                })
            }
        />
    );
}
